import { render, staticRenderFns } from "./FlightInfo.vue?vue&type=template&id=2d858024"
import script from "./FlightInfo.vue?vue&type=script&lang=js"
export * from "./FlightInfo.vue?vue&type=script&lang=js"
import style0 from "./FlightInfo.vue?vue&type=style&index=0&id=2d858024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports